import React from 'react';
import Box, {BoxProps} from '@material-ui/core/Box';
import LinearProgress, {LinearProgressProps} from '@material-ui/core/LinearProgress';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    barRoot: {
        height: '100%',
        backgroundColor: 'transparent'
    },
    barColorPrimary: {
        backgroundColor: '#56198E'
    }
}));

export interface PercentBarProps {
    value: number;
    BoxProps?: BoxProps;
    LinearProgressProps?: LinearProgressProps;
}

const PercentBar: React.FC<PercentBarProps> = ({value, BoxProps, LinearProgressProps}) => {
    const styles = useStyles();
    return (
        <Box position="relative" height="100%" width="100%" zIndex={1} {...BoxProps}>
            <LinearProgress
                classes={{
                    root: styles.barRoot,
                    barColorPrimary: styles.barColorPrimary
                }}
                variant="determinate"
                value={value}
                {...LinearProgressProps}
            />
        </Box>
    );
};

export default PercentBar;
